import { render, staticRenderFns } from "./CardOrdineMTM.vue?vue&type=template&id=68280aee&scoped=true"
import script from "./CardOrdineMTM.vue?vue&type=script&lang=ts"
export * from "./CardOrdineMTM.vue?vue&type=script&lang=ts"
import style0 from "./CardOrdineMTM.vue?vue&type=style&index=0&id=68280aee&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68280aee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68280aee')) {
      api.createRecord('68280aee', component.options)
    } else {
      api.reload('68280aee', component.options)
    }
    module.hot.accept("./CardOrdineMTM.vue?vue&type=template&id=68280aee&scoped=true", function () {
      api.rerender('68280aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mtm/CardOrdineMTM.vue"
export default component.exports